<template>
  <v-dialog @input="toggleModal()"
            max-width="500"
            :value="value">
    <v-card class="error pa-6">
      <v-card-text>
        <span class="justify-center white--text d-block text-center text-h6">
          {{ title }}
        </span>
        <p class="white--text text-center mt-2 mb-0"
           v-if="subtitle">
          {{ subtitle }}
        </p>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn @click="toggleModal()"
               class="mr-2"
               dark
               outlined>
          {{ $t('general.cancel') }}
        </v-btn>

        <v-btn @click="deleteItem()"
               color="white"
               class="error--text"
               :loading="loading">
          {{ $t('general.accept') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '@/plugins/i18n/index.js'
export default {
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async deleteItem () {
      if (this.loading) return
      try {
        this.loading = true
        await this.$emit('deleteItem')
        this.loading = false
        this.toggleModal()
      } catch (e) {
        this.loading = false
      }
    },
    toggleModal () {
      this.$emit('input', false)
    }
  },
  props: {
    subtitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: i18n.t('general.doYouWantToDeleteThisItem')
    },
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>
